/*! js-cookie v3.0.5 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));



// if ( document.location.hash == '#archive' ) {
//   Cookies.set('archive', 'true', { expires: 7, path: '/' });
// }


document.addEventListener("DOMContentLoaded", function() {


  var el;


  

  el = document.querySelector('body.section-archive .sticky-logo a');
  if ( el ) {


    el.href = '/collections/archive';

  }

  el = document.querySelector('.archive-login-wrapper button');
  if ( el ) {

    el.addEventListener('click', function(event) {
      event.preventDefault();



      var input = document.querySelector('.login-wrap input[type=text]');
      var code = input.value;


      if ( code.toLowerCase() == 'chooselove' ) {


        Cookies.set('archive-logged-in', 'true', { expires: 1, path: '/' }); 

        document.location.reload();

/*

      if ( code.length == 10 ) {

      let data = new URLSearchParams();
          data.append('code', code);


      fetch('https://sisyphus.ariesarise.com/aries-sales/unidays/code/claim', {method: 'post', body:  data})
      .then(response => response.json())  // Parse JSON data
      .then(data => { if ( data == true ) { Cookies.set('archive-logged-in', 'true', { expires: 1, path: '/' }); document.location.reload(); } else { input.classList.add('error'); input.placeholder = 'Enter a valid code'; input.value = ''; } })     // Handle the data
      .catch(error => { input.classList.add('error'); input.placeholder = 'Enter a valid code'; input.value = ''; } );  // Handle errors

      

      //Cookies.set('archive-logged-in', 'true', { expires: 1, path: '/' });
      //document.location.reload();

*/

    }
    else {

      input.classList.add('error');
      input.placeholder = 'Enter a valid code';
      input.value = '';

    }

    });

  }


  
  el = document.querySelector('body.section-archive .collection-title');
  if ( el ) {
    el.addEventListener('click', function(event) {
      document.location.href = '/collections/archive';
    });
  }


  el = document.querySelector('a.archive-logout');
  if ( el ) {
    el.addEventListener('click', function(event) {
      event.preventDefault();
      //Cookies.remove('archive-logged-in', 'true', { expires: 1, path: '/' });
      document.location.href = '/';
    });
  }

  el = document.querySelector('a.archive-logout');
  if ( Cookies.get('archive-logged-in') != 'true' ) {

    if ( el ) {
      el.parentElement.removeChild(el);
    }

  }


  el = document.querySelector('.countdown-wrap');
  if ( el ) {

    var countDownDate = new Date("Mar 05, 2026 11:00:00").getTime();

    console.log(countDownDate);

    var x = setInterval(function() {
      // Get today's date and time
      var now = new Date().getTime();
      
      // Calculate the distance between now and the target date
      var distance = countDownDate - now;
      
      // Calculate days, hours, minutes, and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);


      document.querySelector('.countdown-wrap .hours .number').innerHTML = ((days * 24) + hours).toString().padStart(2, '0');
      document.querySelector('.countdown-wrap .minutes .number').innerHTML = minutes.toString().padStart(2, '0');
      document.querySelector('.countdown-wrap .seconds .number').innerHTML = seconds.toString().padStart(2, '0');
      

      
    }, 1000);
    document.querySelector('.countdown-wrap .hours')

  }

});



if ( Cookies.get('archive-logged-in') == 'true' ) {


  if ( !document.body.classList.contains('section-archive') ) {
    //document.location.href = '/collections/archive';
  }

  var wrapper = document.querySelector('.archive-login-wrapper');

  wrapper.parentElement.removeChild(wrapper);

}
else {


    //if ( document.body.classList.contains('section-archive') && !document.body.classList.contains('collection-archive') && !document.body.classList.contains('collection-archive-tshirts') ) {
    //  document.location.href = '/';
    //}
}
